import React, { useState, useEffect, useContext } from "react";
import { Form, Button, Container, Toast, ToastContainer } from 'react-bootstrap';

import { useNavigate, useParams } from "react-router-dom";

import { AuthContext } from "../../contexts/auth";

import { permite_acesso } from "../../services/api";

import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/Row";

const Notification = ({ show, message, variant, onClose }) => (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
        <Toast onClose={onClose} show={show} delay={5000} autohide bg={variant.toLowerCase()}>
            <Toast.Header>
                <strong className="me-auto">Sistema</strong>
            </Toast.Header>
            <Toast.Body className={variant === 'Success' ? 'text-white' : ''}>
                {message}
            </Toast.Body>
        </Toast>
    </ToastContainer>
);

const UploadGPT = () => {

    let { cod_unidade } = useParams();

    const navigate = useNavigate();
    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']


    const [matricula, setMatricula] = useState('');
    const [files, setFiles] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false); // Estado para controlar o botão
    const [showToast, setShowToast] = useState(false);
    const [toastMsg, setToastMsg] = useState('');
    const [toastVariant, setToastVariant] = useState('success'); // 'success' ou 'danger'

    const handleShowMessage = (msg, variant) => {
        setToastMsg(msg);
        setToastVariant(variant);
        setShowToast(true);
    };

    const token = localStorage.getItem("token");

    // CONTROLE(FUNCIONARIO,TOKEN,COD_UNI)

    const { authenticated, logout } = useContext(AuthContext);
    const [acesso, setAcesso] = useState(false);


    const perfil = JSON.parse(localStorage.getItem("perfil"));
    const usuario = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        (async () => {
            const resultado2 = await permite_acesso(usuario[0].email, token, "Unidade " + cod_unidade);
            setAcesso(resultado2);
        })();
    }, []);

    console.log("Acesso:", acesso);



    if (!acesso) {

        return (
            <div className="AcessoNegado">
                -- ACESSO NEGADO !!! --

                <a href="/login"> Voltar ao Login</a>

            </div>
        )
    }
    const handleSubmit = async (event) => {
        event.preventDefault();


        const formData = new FormData();
        formData.append('matricula', matricula);
        for (const file of files) {
            formData.append('contratos', file);
        }

        setIsSubmitting(true); // Desabilita o botão de "Enviar"

        try {
            //const response = await fetch(`http://192.168.1.214:3333/upload_GPT`, {
            // const response = await fetch('https://back.smrede.net.br/upload_GPT', {
            const response = await fetch(process.env.REACT_APP_BACKEND2 + '/upload_GPT', {
                method: 'POST',
                body: formData
            });
            if (response.ok) {
                handleShowMessage("Contrato enviado com sucesso!", "success");
                setMatricula('');
                setFiles([]);
                // alert('Comprovantes enviados com sucesso!');
            } else {
                const errorData = await response.json();
                handleShowMessage(errorData.resultado || "Erro ao enviar o arquivo", "danger");
                console.log('retorno:', response)
                response.json().then(errorData => {
                    // Manipula a resposta de erro aqui
                    // console.log('Erro de validação:', errorData);
                    handleShowMessage(errorData.resultado || "Erro ao validar", "danger");

                })

            }
        } catch (error) {
            handleShowMessage("Erro de conexão com o servidor", "danger");
            console.error(error.message);

        } finally {
            setIsSubmitting(false); // Reabilita o botão após o retorno
        }
    };

    return (
        <div className="upload">
            <Notification
                show={showToast}
                message={toastMsg}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
            <br></br>
            <center>
                <h2 className='h11'> <b> Envio de Contratos de Ensino </b> - {unidades[parseInt(cod_unidade)]}</h2>
            </center>
            <p></p>
            <Container className='Meio01'>

                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="matricula">
                        <Form.Label><b>Matricula do aluno </b></Form.Label>
                        <Form.Control type="text" placeholder="Matricula" value={matricula} onChange={(e) => setMatricula(e.target.value)} required />
                    </Form.Group>
                    <br />
                    <Form.Group controlId="contratos">
                        <Form.Label>Contrato</Form.Label>
                        <Form.Control type="file" name="contratos" onChange={(e) => setFiles(e.target.files)} required />
                    </Form.Group>
                    <br />
                    <div className='d-grid gap-2'>
                        <Row>
                            <Col md={6} lg={6} >
                                <center>
                                    <Button className="but2" variant="warning" onClick={(e) => navigate(`/`)} > <i className="fa-solid fa-left-long"></i> VOLTAR </Button>
                                </center>
                            </Col>
                            <Col md={6} lg={6} >
                                <center>
                                    <Button variant="success" type="submit" size="lg" disabled={isSubmitting}>
                                        {isSubmitting ? "Enviando..." : "Enviar"} {isSubmitting ? <i className="fa-solid fa-spinner fa-spin-pulse"></i> : <i className="fa-solid fa-file-arrow-up"></i>}
                                    </Button>
                                </center>
                            </Col>
                        </Row>
                    </div>
                </Form>
            </Container>
        </div>
    );
}
export default UploadGPT;